<script setup>
import { frames } from '../../../../utils/frames'
const gsapTimeline = useGsapTimeline()

defineProps({
  text: String,
})

const emit = defineEmits(['timeline', 'timelineOut'])

const textElement = ref(null)

onMounted(() => {
  const timeline = gsapTimeline({ name: 'TextSlideUpFade' })
    .startInvisible(textElement)
    .from(textElement, { yPercent: 40, opacity: 0, duration: frames(36, 50), ease: 'power3.inOut' }, '<')

  emit('timeline', timeline)

  const timelineOut = () => gsapTimeline({ name: 'TextSlideUpFade - Out' }).to(textElement, { yPercent: 40, opacity: 0, duration: frames(36, 50), ease: 'power3.inOut' }, '<')
  emit('timelineOut', timelineOut)
})
</script>

<template>
  <div ref="textElement" v-html="text" />
</template>
